import { graphql } from '@shared/api/gql';

export const authenticateAdminQueryDocument = graphql(`
	query AuthenticateAdmin($password: String!) {
		authenticateAdmin(password: $password) {
			token
			expiredAt
		}
	}
`);
